import analyze from 'rgbaster'

export default function useColor() {
  const blackAndWhite = ['rgb(255,255,255)', 'rgb(0,0,0)', 'rgb(1,1,1)']

  const getPredominantColors = async (
    img: string,
    ignoredColors?: boolean,
    defaultColor?: string
  ): Promise<{
    primary: string
    secondary: string
  }> => {
    try {
      const result = ignoredColors ? await analyze(img, { ignore: blackAndWhite }) : await analyze(img)

      return {
        primary: rgbToHex(result[0]?.color ?? defaultColor),
        secondary: rgbToHex(result[1]?.color ?? defaultColor)
      }
    } catch {
      return null
    }
  }

  const rgbToHex = (rgb?: string) => {
    if (!rgb) {
      return
    }
    const rgbString = rgb.split('(')[1].split(')')[0]
    const rgbArray = rgbString.split(',')
    const rgbValues = rgbArray.slice(0, 3)

    const hex = rgbValues.map((x) => {
      x = parseInt(x.trim()).toString(16)
      return x.length == 1 ? `0${x}` : x
    })
    return `#${hex.join('')}`
  }

  const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : null
  }

  const getContrast = (color: string) => {
    if (!color) {
      return '#334155'
    }

    const hc = color.replace('#', '')
    const [r, g, b] = [0, 2, 4].map((p) => parseInt(hc.substr(p, 2), 16))
    const yiq = (r * 299 + g * 587 + b * 114) / 1000 >= 186
    return yiq ? '#334155' : '#FFFFFF'
  }

  const setDocumentColor = (type: string, color: string) => {
    const value = hexToRgb(color)
    document.documentElement.style.setProperty(`--color-${type}`, `${value?.r}, ${value?.g}, ${value?.b}`)
    document.documentElement.style.setProperty(`--color-${type}-hover`, `${value?.r}, ${value?.g}, ${value?.b}, .75`)
  }

  return {
    blackAndWhite,
    getContrast,
    getPredominantColors,
    setDocumentColor
  }
}
